export const validationMap = {
  type: {
    helperText: 'Field is required',
    isError: (value: string|undefined): boolean => !value?.length,
  },
  title: {
    helperText: 'Field is required',
    isError: (value: string|undefined): boolean => !value?.length,
  },
};
